<template>
    <PageContent slug="cookies" />
</template>

<script setup>
import PageContent from './PageContent.vue'
</script>

